import React, { useEffect, useState } from 'react';
import { ANALYTIC, COUNT, DATA_CONFIGURATION, DEFAULT_VALUE, ENTER, MAX, MAX_CHAR_COUNT, MAX_COUNT, MAX_QUANTITY, MIN, MIN_COUNT, MIN_QUANTITY, QUANTITY, REQUIRED } from '../ISRConstants';
import { TConnector, TField, TFieldDataConfiguration, TProductCategory, TSubmodel } from '../Pages/DefineModel/model';
import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';

type TextConfigurationProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    updateFieldDataConfiguration: (updatedConfig: TFieldDataConfiguration) => void;
}

const TextConfiguration = ({id, selectedItem, updateFieldDataConfiguration} : TextConfigurationProps) => {
    const [fieldDataConfiguration, setFieldDataConfiguration] = useState<TFieldDataConfiguration>({});

    useEffect(() => {
        const existingValue = selectedItem && 'dataConfiguration' in selectedItem && selectedItem?.dataConfiguration ? selectedItem.dataConfiguration : {}
        setFieldDataConfiguration(existingValue);
    }, [selectedItem]);

    useEffect(() => {
        const hasChanges = Object.keys(fieldDataConfiguration).some(
            (key) => fieldDataConfiguration[key as keyof TFieldDataConfiguration] !== undefined
        );
        if (hasChanges) {
            updateFieldDataConfiguration(fieldDataConfiguration);
        }
    }, [fieldDataConfiguration]);


    const handleMaxCharacterCountChange = (value: number) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, maxCharacterCount: value}));
    };

    const handleIncrementChange = (value: string) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, defaultValue: value}));
    };

    const handleRequiredChange = (value: boolean) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, fieldRequired: value}));
    }

    const handleAnalyticChange = (value: boolean) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, enableAnalytic: value}));
    }

    const handleMinMaxFields = (value: number, property: string) =>{
        setFieldDataConfiguration((prevConfig) => {
            if(!prevConfig) return prevConfig
            const updatedData = {
                ...prevConfig,
                [property]: value
            }
            return updatedData
        })
    }
        
    return (
        <div id={id} className='cart-style-dm'>
            <label id={`${id}-title`} className='cart-title'>{DATA_CONFIGURATION}</label>
            <div id={`${id}-main-config`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-char-count-container`} className='tw-w-[20%]'>
                    <label id={`${id}-char-count-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX_CHAR_COUNT}</label>
                    <input 
                        id={`${id}-char-count-input`}
                        className="tw-rounded tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        type='number'
                        value={fieldDataConfiguration.maxCharacterCount || ''}
                        onChange={(e) => handleMaxCharacterCountChange(Number(e.target.value))}
                        placeholder={ENTER} 
                    />
                </div>
                <div id={`${id}-default-value-container`} className='tw-w-[36%] tw-ms-5'>
                    <label id={`${id}-default-value-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{DEFAULT_VALUE}</label>
                    <input 
                        id={`${id}-default-value-input`}
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        type='text'
                        value={fieldDataConfiguration.defaultValue|| ''}
                        onChange={(e) => handleIncrementChange(e.target.value)}
                        placeholder={ENTER} 
                    />
                </div>
                <div id={`${id}-required-container`} className='tw-w-[10%] tw-ms-5'>
                    <label id={`${id}-required-label`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-1'>{REQUIRED}</label>
                    <ToggleButton
                        id={`${id}-required-toggle`}
                        name="Required" 
                        value={fieldDataConfiguration?.fieldRequired ?? false} 
                        onChange={(e) => handleRequiredChange(e.target.checked)} 
                    />
                </div>
                {/* <div id={`${id}-analytic-container`} className='tw-w-[10%] tw-ms-5'>
                    <div className='tw-flex tw-items-center tw-gap-1 tw-mb-1'>
                        <label id={`${id}-analytic-label`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-1'>{ANALYTIC}</label>
                    </div>
                    <ToggleButton
                        id={`${id}-analytic-toggle`}
                        name={ANALYTIC}
                        value={fieldDataConfiguration?.enableAnalytic ?? false}
                        onChange={(e) => handleAnalyticChange(e.target.checked)} 
                    />
                </div> */}
            </div>
            <>
                <label id={`${id}-count-title`} className='cart-title tw-mt-2'>{COUNT}</label>
                <div id={`${id}-count-section`} className='tw-flex tw-items-center tw-mt-2'>
                    <div id={`${id}-count-min-container`} className='tw-w-[20%]'>
                        <label id={`${id}-count-min-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MIN}</label>
                        <input
                            id={`${id}-count-min-input`}
                            className="input-field-dm"
                            type='number'
                            value={fieldDataConfiguration?.minCount ?? 0}
                            onChange={(e) => handleMinMaxFields(Number(e.target.value), MIN_COUNT)}
                            placeholder={ENTER} 
                        />
                    </div>
                    <div id={`${id}-count-max-container`} className='tw-w-[20%] tw-ms-5'>
                        <label id={`${id}-count-max-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX}</label>
                        <input
                            id={`${id}-count-max-input`}
                            className="input-field-dm"
                            type='number'
                            value={fieldDataConfiguration?.maxCount ?? 0}
                            onChange={(e) => handleMinMaxFields(Number(e.target.value), MAX_COUNT)}
                            placeholder={ENTER} 
                        />
                    </div>
                </div>
                <label id={`${id}-quantity-title`} className='cart-title tw-mt-2'>{QUANTITY}</label>
                <div id={`${id}-quantity-section`} className='tw-flex tw-items-center tw-mt-2'>
                    <div id={`${id}-quantity-min-container`} className='tw-w-[20%]'>
                        <label id={`${id}-quantity-min-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MIN}</label>
                        <input
                            id={`${id}-quantity-min-input`}
                            className="input-field-dm"
                            type='number'
                            value={fieldDataConfiguration?.minQuantity ?? 0}
                            onChange={(e) => handleMinMaxFields(Number(e.target.value), MIN_QUANTITY)}
                            placeholder={ENTER} 
                        />
                    </div>
                    <div id={`${id}-quantity-max-container`} className='tw-w-[20%] tw-ms-5'>
                        <label id={`${id}-quantity-max-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX}</label>
                        <input
                            id={`${id}-quantity-max-input`}
                            className="input-field-dm"
                            type='number'
                            value={fieldDataConfiguration?.maxQuantity ?? 0}
                            onChange={(e) => handleMinMaxFields(Number(e.target.value), MAX_QUANTITY)}
                            placeholder={ENTER} 
                        />
                    </div>
                </div>
            </>
        </div>
    );
}

export default TextConfiguration;